import { render, staticRenderFns } from "./MessagesTask.vue?vue&type=template&id=7f26fe8a&scoped=true&"
import script from "./MessagesTask.vue?vue&type=script&lang=js&"
export * from "./MessagesTask.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTask.vue?vue&type=style&index=0&id=7f26fe8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26fe8a",
  null
  
)

export default component.exports